import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import Loader from 'JS/components/FullScreenLoader.vue';
import TrackOrderService from '../services/TrackOrderService';
import { BForm, BSubmitButton, BTextField } from 'JS/components/blain-form';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackYourOrder',
  props: {
    loggedInCustomer: null
  },
  setup(__props: any) {

const props = __props as {
	loggedInCustomer?: {
		email: string
	}
}



const _orderService = new TrackOrderService();

const email = ref<string>(props.loggedInCustomer.email ?? '');
const orderId = ref<string>();
const searchError = ref<string>('');
const loading = ref(false);

async function searchOrder(): Promise<void> {   
	try {
		loading.value = true;
		const response = await _orderService.searchOrder(email.value, orderId.value);

		if (response.error) {
			loading.value = false;
			showSearchError(response.error);
		} else {
			window.location.assign(`${window.location.origin}/account/orders/${orderId.value}/${response.orderHashUrlParameter}/`);
		}
	} catch (error) {
		loading.value = false;
		showSearchError('Something went wrong... ');
		throw error;
	}
}

const showSearchError = (error: string) => searchError.value = error;

const clearSearchError = () => searchError.value = '';

return { __sfc: true,props, _orderService, email, orderId, searchError, loading, searchOrder, showSearchError, clearSearchError, validation, ErrorBanner, Loader, BForm, BSubmitButton, BTextField }
}

})